export default {
  allowAlignment: true,
  allowImage: true,
  allowButton: false,
  allowVideo: false,
  allowSocial: false,
  allowHeading: true,
  allowSubheading: true,
  allowUploads: false,
  allowAttachments: false,
  allowCode: false,
  allowImageText: true,
  allowAnchor: true
};